import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { resetPasswordRequest } from "../api/auth.api";
import "./Login.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      toast.error("Lien invalide ou expiré.");
      return;
    }

    if (!password || !confirm) {
      toast.error("Veuillez remplir tous les champs.");
      return;
    }

    if (password !== confirm) {
      toast.error("Les mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);

    try {
      await resetPasswordRequest(token, password);
toast.success("Mot de passe réinitialisé avec succès !");

      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      console.error("❌ Reset password error:", err);
      toast.error(err.message || "Erreur lors de la réinitialisation");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toaster position="top-right" richColors />
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="login-icon-wrapper">
              <svg
                className="login-svg-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 11c0-.552-.448-1-1-1H9V8c0-.552.448-1 1-1h2c1.105 0 2 .895 2 2v1c0 1.105-.895 2-2 2zM12 15h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"
                />
              </svg>
            </div>
            <h1 className="login-title">Réinitialiser le mot de passe</h1>
            <p className="login-description">
              Choisissez un nouveau mot de passe sécurisé.
            </p>
          </div>

          <div className="login-content">
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="password" className="form-label">
                  Nouveau mot de passe
                </label>
                <div className="password-wrapper">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-input password-input"
                    placeholder="••••••••"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="password-toggle-btn"
                  >
                    <i
                      className={`fas ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      }`}
                    ></i>
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="confirm" className="form-label">
                  Confirmer le mot de passe
                </label>
                <input
                  id="confirm"
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="form-input"
                  placeholder="••••••••"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="submit-btn"
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    Réinitialisation...
                  </>
                ) : (
                  <>
                    <i className="fas fa-unlock"></i>
                    Réinitialiser
                  </>
                )}
              </button>

              <div className="login-footer">
                <p className="footer-text">
                  Retour à la page{" "}
                  <Link to="/login" className="register-link">
                    de connexion
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
